export default (config = {}, selected) => {
    config.options = config.options.map((option) => {
        return {
            [config.trackBy]: String(option[config.trackBy]),
            [config.label]: String(option[config.label])
        };
    });

    return {
        model: selected,
        options: config.options,
        trackBy: config.trackBy,
        label: config.label,
        readonly: config.readonly,
        placeholder: config.placeholder,

        search: null,
        isOpen: false,

        get filteredOptions() {
            if (this.search) {
                let search = this.search.toLowerCase();

                return this.options.filter((option) => {
                    return this.optionLabel(option).toLowerCase().includes(search);
                });
            }

            return this.options;
        },
        get selected() {
            let option = this.options.find((option) => {
                return this.model == this.optionKey(option);
            });

            return option ?
                option :
                null;
        },
        get hasSelected() {
            return this.selected !== null && this.selected !== undefined;
        },

        select(option) {
            if (!this.readonly) {
                this.model = this.optionKey(option);
            }
        },
        isSelected(option) {
            return this.model == this.optionKey(option);
        },
        remove(option) {
            if (!this.readonly) {
                this.model = null;
            }
        },
        empty() {
            if (!this.readonly) {
                this.model = null;
            }
        },

        openOptions() {
            if (!this.readonly) {
                this.isOpen = true;
                this.$refs.searchField.focus();
            }
        },
        closeOptions() {
            if (!this.readonly) {
                this.isOpen = false;
                this.search = null;
            }
        },

        optionLabel(option) {
            return option ? option[this.label] : '';
        },
        optionKey(option) {
            return option ? option[this.trackBy] : '';
        }
    };
}